module.exports = __webpack_public_path__ + "static/media/orca.0f0ab383.png";